<template>
  <svg :width="size" :height="size" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M38.9167 21C40.6196 21 42.0232 22.3878 41.7741 24.0723C41.2344 27.7212 39.7398 31.1831 37.4171 34.095C34.45 37.8148 30.3077 40.4167 25.6686 41.4745C21.0296 42.5323 16.1688 41.9833 11.8825 39.9175C7.59619 37.8516 4.13851 34.3914 2.07583 30.1036C0.0131451 25.8158 -0.532253 20.9546 0.528971 16.3163C1.5902 11.678 4.19513 7.5376 7.91707 4.57329C11.639 1.60898 16.2573 -0.00349353 21.0154 5.67875e-06C24.7403 0.00274496 28.3779 0.995656 31.5657 2.85149C33.0373 3.70825 33.2455 5.6711 32.1826 7.00155C31.1198 8.33201 29.1884 8.51474 27.6672 7.74938C25.6145 6.7166 23.3368 6.16831 21.0109 6.1666C17.65 6.16413 14.3878 7.3031 11.7588 9.39695C9.12984 11.4908 7.28984 14.4154 6.54024 17.6917C5.79064 20.9679 6.17588 24.4016 7.63286 27.4304C9.08984 30.4591 11.5322 32.9032 14.5598 34.3624C17.5875 35.8216 21.0209 36.2094 24.2977 35.4622C27.5745 34.715 30.5005 32.8772 32.5962 30.2497C34.0466 28.4314 35.0399 26.3096 35.5141 24.0612C35.8656 22.395 37.2138 21 38.9167 21Z" :fill="color"></path>
    <defs>
      <radialGradient id="paint0_angular_10280_78712" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(7.99961 7.99961) rotate(-90.0007) scale(7.5001)">
        <stop offset="0.0729563" stop-color="#A1A8B8"/>
        <stop offset="0.255792" stop-color="#A1A8B8" stop-opacity="0"/>
      </radialGradient>
    </defs>
  </svg>
</template>

<script>
export default {
  props:{
    color:{
      default:'#A1A8B8'
    },
    size:{
      default: '20'
    }
  }
}
</script>

<style>

</style>